import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import { scrollRhsToTop } from 'uplisting-frontend/pods/-sidebar/utils';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';
import ActionChangeoversController from 'uplisting-frontend/pods/action/changeovers/controller';

interface IParams extends Record<string, unknown> {
  changeover_id: string;
}

export default class SidebarChangeoversRoute extends PermittedRoute {
  @service('repositories/changeover')
  changeoverRepository!: Services['repositories/changeover'];

  permission = 'changeover.view';

  model(params: IParams) {
    return this.changeoverRepository.findRecord(params.changeover_id, {
      reload: true,
    });
  }

  setupController(
    controller: ActionChangeoversController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { changeover: model });

    scrollRhsToTop(this);
  }
}
